
function ymmQuery(userQuery, count) {
    return [
        // -- Each .autocomplete field as a separate named match query --
        {
            match: {
                "subcategories.autocomplete": {
                    query: userQuery,
                    boost: 6 * count,
                    _name: "subcategories_autocomplete",
                    fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },
        {
            match: {
                "make.autocomplete": {
                    query: userQuery,
                    boost: 8 * count,
                    _name: "make_autocomplete",
                    // fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },
        {
            match: {
                "model.autocomplete": {
                    query: userQuery,
                    boost: 10 * count,
                    _name: "model_autocomplete",
                    // fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },


        {
            match: {
                model: {
                    query: userQuery,
                    boost: 30 * count,
                    _name: "model_match_exact",
                    fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },
        {
            match: {
                make: {
                    query: userQuery,
                    boost: 25 * count,
                    _name: "make_match_exact",
                    fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },
        {
            match: {
                subcategories: {
                    query: userQuery,
                    boost: 100 * count,
                    _name: "subcategories_match",
                    fuzziness: 1,
                    prefix_length: 2,
                }
            }
        },


        {
            match_phrase: {
                make: {
                    query: userQuery,
                    boost: 40 * count,
                    _name: "make_match_phrase_exact"
                }
            }
        },
        {
            match_phrase: {
                model: {
                    query: userQuery,
                    boost: 45 * count,
                    _name: "model_match_phrase_exact"
                }
            }
        },
    ]
}

function patioQuery(userQuery, count) {
    return [
        {
            match: {
                "title.autocomplete": {
                    query: userQuery,
                    boost: 20 * count,
                    fuzziness: 1,
                    prefix_length: 2,
                    _name: "title_autocomplete_match"
                }
            },
        },
        {
            match: {
                "title": {
                    query: userQuery,
                    boost: 30 * count,
                    fuzziness: 1,
                    prefix_length: 2,
                    _name: "title_match_exact"
                }
            },
        },
        {
            match: {
                "title.synonyms": {
                    query: userQuery,
                    boost: 30 * count,
                    _name: "title_synonyms_match_exact"
                }
            }
        },
        // subcategories
        {
            match: {
                "subcategories": {
                    query: userQuery,
                    boost: 10 * count,
                    _name: "subcategories_match_exact"
                }
            }
        },
        {
            match: {
                "category": {
                    query: userQuery,
                    boost: 10 * count,
                    _name: "category_match_exact"
                }
            }
        }
    ]
}

/**
 * Perform the same user query across multiple categories with _msearch.
 * @param {string} userQuery - The text the user typed, e.g., "Merce"
 * @param {string[]} categories - Array of categories, e.g. ["Car Cover", "Boat Cover"]
 * @returns {Promise<object>} The _msearch response (with .responses[] for each category)
 */
async function multiSearchByCategory(userQuery, categories, emptyQuery) {
    const url = "https://seal-skin-covers.es.us-east-2.aws.elastic-cloud.com";
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-ndjson");
    myHeaders.append("Authorization", "Basic ZWxhc3RpYzplN1VtNm5YVFYyWHBLQkd3aEx3bWZpNTU=");

    // 1) Build the NDJSON request body for _msearch.
    //    For each category, we create two lines:
    //    1) { "index": "products" }
    //    2) Our query JSON
    let ndjsonBody = "";
    let count = 3;
    for (const cat of categories) {

        let isPatio = typeof cat.value === "object";

        // The first line: index metadata (which index to search).
        ndjsonBody += JSON.stringify({ index: "products" }) + "\n";
        count -= 0.1;

        const searchObject = {
            query: {
                function_score: {
                    query: {
                        bool: {
                            must: [
                                // 1) We use a bool/should block to replicate your "OR" logic across fields.
                                {
                                    bool: {
                                        should: isPatio ? patioQuery(userQuery, count) : ymmQuery(userQuery, count),
                                    }
                                },
                                // 2) Filter results to the current category
                                isPatio ? cat.value : {match_phrase: {title: cat.value}}
                            ]
                        }
                    },
                    functions: [
                        {
                            field_value_factor: {
                                field: "orders_count",
                                factor: isPatio ? 1.0 : 10.0,
                                modifier: isPatio || emptyQuery ? "none" : "ln1p",
                            },
                        },
                    ],
                    boost_mode: "sum",
                    /*
                       'boost_mode' determines how the function score
                       combines with the bool query's score.
                       - sum  => finalScore = originalScore + fieldValueFactor
                       - multiply => finalScore = originalScore * fieldValueFactor
                       - max, avg, min also possible
                    */
                }
            },
            sort: ["_score"],
            size: isPatio ? 200 : 8,
            highlight: {
                fields: {
                    make: {},
                    model: {},
                    option: {}
                }
            }
        };

        ndjsonBody += JSON.stringify(searchObject) + "\n";
    }

    // 2) Send _msearch request
    const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: ndjsonBody,
        redirect: "follow"
    };

    const response = await fetch(`${url}/_msearch`, requestOptions);
    if (!response.ok) {
        throw new Error(`Elasticsearch error: ${response.status} ${response.statusText}`);
    }

    // 3) Parse and return the JSON response
    const data = await response.json();
    return data; // data.responses[] is an array of search results, one for each category
}

/**
 * Accumulate all keywords from the categories into a single array, and remove duplicates.
 * These keywords are removed from the user query.
 *
 * @param categories
 * @returns {*}
 */
function accumulateKeywords(categories) {
    let keywords = categories.reduce((acc, cat) => {
        if(cat.keywords) {
            for(let keyword of cat.keywords) {
                if(!acc.includes(keyword)) {
                    acc.push(keyword);
                }
            }
        }
        return acc;
    }, ['cover', 'covers']);

    return keywords;
}

/**
 * Remove keywords from the user query.
 * If the query is empty after removing keywords, set it to "cover", so that we can show all products.
 *
 * @param userQuery
 * @param keywords
 * @returns {{emptyQuery: boolean, modifiedQuery: string, userQuery}}
 */
function modifyQuery(userQuery, keywords) {
    let emptyUserQuery = userQuery.trim() === "";
    let emptyQuery = false;
    let modifiedQuery = userQuery;

    for (const keyword of keywords) {
        const regex = new RegExp(`\\b${keyword}\\b`, "gi");
        modifiedQuery = modifiedQuery.replace(regex, "");
    }

    modifiedQuery = modifiedQuery.trim();

    if (modifiedQuery === "") {
        modifiedQuery = "cover";
        emptyQuery = true;
    }

    return { modifiedQuery, emptyQuery, userQuery, emptyUserQuery };
}

/**
 * Filter out categories that are not relevant to the user query.
 *
 * @param userQuery
 * @param categories
 * @returns {Array}
 */
function filterCategories(categories, userQuery, modifiedQuery, emptyUserQuery) {

    if(emptyUserQuery) {
        return categories.filter(cat => {
            return cat.trending;
        })
    }

    let filteredCategories = categories.filter(cat => {
        let keywords = (cat._keywords || []).concat(cat.keywords || []);
        if(keywords) {
            for(const keyword of keywords) {
                if(userQuery.toLowerCase().includes(keyword)) {
                    return true;
                }
            }
        }
        return false;
    });

    return filteredCategories.length > 0 ? filteredCategories : categories;
}


function countExactHits(category) {
    let hits = category.hits.hits || category.hits;

    let count = 0;

    for(let hit of hits) {
        let exactHits = hit.matched_queries.filter(query => query.includes('exact')).length;
        if(exactHits > 0) count++;
    }

    return count;
}

function countColumnExactHits(categories, category) {
    let count = 0;


    if(category.name === 'patio') {
        categories.filter(cat => cat.name === 'patio').forEach(cat => {
            count += countExactHits(cat)
        });
    } else {
        categories.filter(cat => cat.name !== 'patio').forEach(cat => {
            count += countExactHits(cat)
        });
    }


    return count;
}


async function getSearchResultProducts(query) {

    let categories = [
        {
            name: "patio", value: {
                "bool": {
                    "should": [
                        { "match_phrase": { "category": "Patio" } },
                        { "match_phrase": { "category": "Grill & Heating" } },
                        { "match_phrase": { "category": "Industrial & Equipment" } },
                        { "match_phrase": { "category": "Custom Covers" } }
                    ],
                    "minimum_should_match": 1
                }
            },
            _keywords: ["patio", "grill", "heating"],
            displayName: "Patio",
            trending: 10
        }, // 0
        { name: "car", value: "Car Covers", keywords: ["car"], trending: 1 }, // 1
        { name: "truck", value: "Truck Covers", keywords: ["truck"] }, // 2
        { name: "suv", value: "SUV Covers", keywords: ["car", "suv"], trending: 3}, // 3
        { name: "boat", value: "Boat Covers", keywords: ["boat"], trending: 2 }, // 4
        { name: "pontoon", value: "Pontoon Covers", keywords: ["boat", "pontoon"] }, // 5
        { name: "jetski", value: "Jet Ski Covers", keywords: ["boat", "jetski"], trending: 4 }, // 6
        { name: "motorcycle", value: "Motorcycle Covers", keywords: ["motorsports", "motorcycle"] }, // 7
        { name: "snowmobile", value: "Snowmobile Covers", keywords: ["motorsports", "snowmobile"] }, // 8
        { name: "van", value: "Van Covers", keywords: ["van"] }, // 9
        { name: "scooter", value: "Scooter Covers", keywords: ["motorsports", "scooter"] }, // 10
        { name: "utv", value: "UTV Covers", keywords: ["motorsports", "utv"] }, // 11
        { name: "atv", value: "ATV Covers", keywords: ["motorsports", "atv"] }, // 12
        { name: "rv", value: "RV Covers", keywords: ["rv"] }, // 13
    ];

    const keywords = accumulateKeywords(categories);

    const { modifiedQuery, emptyQuery, userQuery, emptyUserQuery } = modifyQuery(query, keywords);

    categories = filterCategories(categories, userQuery, modifiedQuery, emptyUserQuery);

    const results = await multiSearchByCategory(modifiedQuery, categories);

    categories = categories.map((cat, index) => {
        if(results.responses[index].error) {
            console.error(`Error in category ${cat.name}:`, results.responses[index].error);
            return null;
        }

        return {
            ...cat,
            hits: results.responses[index].hits.hits,
            max_score: results.responses[index].hits.max_score,
            total: results.responses[index].hits.total,
            hide: false,
            exactHits: countExactHits(results.responses[index]),
        };
    }).filter(cat => {
        return cat !== null && cat.hits.length > 0;
    }).sort((a,b) => {
        if(emptyUserQuery) {
            return a.trending - b.trending;
        }
        return b.max_score - a.max_score;
    });


    let hasPatio = false;

    // Check if there are any patio products
    categories.forEach(cat => {
        if(cat.name === 'patio') {
            hasPatio = true;
        }
    });

    let patioExactHits = 0;
    let ymmExactHits = 0;

    // Calculate total column exact hits and filter by it
    if( !emptyQuery && hasPatio ) {
        categories = categories.map(cat => {
            let columnExactHits = countColumnExactHits(categories, cat);

            if(cat.name === 'patio') {
                patioExactHits = columnExactHits;
            } else {
                ymmExactHits = columnExactHits;
            }

            return {
                ...cat,
                columnExactHits
            }
        }).map(cat => {
            let hide = false;

            if (cat.columnExactHits < 5 && cat.name !== 'patio') {
                hide = true;
            }

            if(patioExactHits > 6 && cat.name !== 'patio') {
                hide = true;
            }

            return {
                ...cat,
                hide
            }
        });
    }


    // If there are suggestions, limit patio products to 6 ( right column )
    categories = categories.map(cat => {
      if(cat.name === 'patio' && categories.filter(cat => !cat.hide).length > 1) {
          cat.hits = cat.hits.slice(0, 6);
      }
      return cat;
    })

    /**
     * Ready up the categories for display
     */
    let _categories = [];
    let _patioCategories = [];
    let ymmCategoriesCount = 0;

    categories.forEach(cat => {
        if (cat.name === 'patio') {
            let patioCategories = {};
            for (let hit of cat.hits) {
                let product = hit._source;
                let categories = product.subcategories.split(',');
                let categoryUrl = product.category_redirect_url.split(',');
                let currentObject = patioCategories;
                let index = 0;

                for(var category of categories) {
                    category = category.trim();

                    if (!currentObject[category]) {
                        currentObject[category] = {
                            redirectUrl: categoryUrl[index],
                            order: Object.keys(currentObject).length,
                            count: 0,
                            children: {},
                        };
                    }

                    currentObject[category].count++;

                    currentObject = currentObject[category].children;

                    index++;
                }
            }
            function addPatioCategoriesRecursively(categories, depth) {
                for (let categoryName in categories) {
                    category = categories[categoryName];

                    _patioCategories.push({
                        displayTitle: categoryName + (emptyUserQuery ? '' : ` <span>(${category.count})</span>`),
                        internalId: Math.random().toString(36).substring(7),
                        category_redirect_url: category.redirectUrl,
                        depth: depth,
                    });

                    if (category.children) {
                        addPatioCategoriesRecursively(category.children, depth + 1);
                    }
                };
            }

            addPatioCategoriesRecursively(patioCategories, 0);

        } else {
            _categories.push({
                displayTitle: `${cat.displayName || cat.value}` + (emptyUserQuery ? '' : ` <span>(${cat.total.value})</span>`),
                internalId: Math.random().toString(36).substring(7),
                category_redirect_url: cat.hits[0]?._source?.category_redirect_url,
            });

            ymmCategoriesCount++;
        }
    })

    // Add _patioCategories to _categories
    if(emptyQuery) {
        _categories = _categories.concat(_patioCategories);
    } else {
        _categories = _patioCategories.concat(_categories);
    }

    /**
     * Ready up the products for display
     */
    let itemsCount = { 1: 8, 2: 5, 3: 4, 4: 3 };
    let products = [];
    let displayCount = itemsCount[ymmCategoriesCount] || 2;

    categories.forEach(cat => {

        if(cat.hide) return;

        let numToShow = Math.max(1, ymmCategoriesCount < 4 ? displayCount : 8 / ymmCategoriesCount);
        if(cat.name === 'patio') numToShow = 200;

        products.push(...cat.hits.filter((p, index) => index < numToShow).map(hit => {
            let product = hit._source;
            return {
                ...product,
                image: getImage(product),
                displayTitle: getTitle(product),
                category: (!hasPatio ? `${product.category} > ` : '') + `${product.subcategories.split(',').join(' > ')}`,
                group: cat.name === 'patio' ? 'grid' : 'list',
                internalId: Math.random().toString(36).substring(7),
                redirect_url: getRedirectUrl(product, cat),
                category_redirect_url: product.category_redirect_url,
            }
        }));

        if(cat.name !== 'patio') {
            displayCount--;
        }
    })

    return { products, categories: _categories, userQuery, emptyQuery, hasPatio, emptyUserQuery };
}

function getRedirectUrl(product, cat) {
    if(cat.name === 'patio') {
        return `/products/${product.handle}`;
    }

    if(product.redirect_url) {
        return product.redirect_url + '?make=' + product.make + '&model=' + product.model;
    }

    return '';
}

function getImage(product) {
    if(product?.image?.includes('shopify')) {
        let url = new URL(product.image);
        url.searchParams.set('width', 200);
        return url.toString();
    }

    return product.image;
}

function getTitle(product) {
    let title = `${product.make || ''} <b>${product.model || ''}</b>`;
    if([product.make, product.model].join('') === '') {
        title = product.title
    }
    return title;
}

export default getSearchResultProducts;